/* eslint-disable @typescript-eslint/no-explicit-any */
export async function reportFrontendError(error: any) {
  try {
    await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/v1/errors/frontend`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message: error?.message || "Unknown error",
        stack: error?.stack || "",
        url: typeof window !== "undefined" ? window.location.href : "",
        extra: error?.extra || null,
      }),
    });
  } catch (e) {
    console.error("❌ Frontend error failed to send:", e);
  }
}
